import { useRuntimeConfig } from '#app';
export default function (path: string): string {
  const config = useRuntimeConfig();
  return `https://cms1.jpc.africa${path}`;
  // return `${config.public.kenticoMedia}${path}`;
}
